// import 'SRC/js/alerts.js';
// import 'SRC/js/animations.js';
// import 'SRC/js/classes.js';
// import 'SRC/js/cw-gf-file-override.js';
// import 'SRC/js/cw-blocks.js';
// import 'SRC/js/faqs.js';
// import 'SRC/js/footer.js';
// import 'SRC/js/galleries.js';
// import 'SRC/js/hashscroll.js';
import 'SRC/js/hotlinks.js';
// import 'SRC/js/lazyload.js';
// import 'SRC/js/locations.js';
// import 'SRC/js/maps.js';
import 'SRC/js/navigation.js';
import 'SRC/js/portfolio.js';
// import 'SRC/js/promos.js';
// import 'SRC/js/scroll-reveal.js';
// import 'SRC/js/search.js';
// import 'SRC/js/services.js';
// import 'SRC/js/sidebar.js';
import 'SRC/js/slideshow.js';
import 'SRC/js/staff.js';
// import 'SRC/js/testimonials.js';
import 'SRC/js/utilities.js';